import { ILanguage } from "../types";

export const arSA: ILanguage = {
  translation: {
    root: {
      customize: "تخصيص",
      businessAccount: "حساب أعمال",
      verificationStatus: "حالة التحقق",
      companyInformation: "معلومات الشركة",
      note: "ملاحظة",
      mode: "الوضع",
      comments: "تعليقات",
      businessName: "اسم العمل",
      enterBusinessName: "أدخل اسم العمل",
      registrationNumber: "رقم تسجيل الشركة",
      registrationNumberPlaceholder: "أدخل رقم التسجيل",
      taxVat: "رقم التسجيل الضريبي/القيمة المضافة",
      vatPlaceholder: "أدخل رقم التسجيل الضريبي/القيمة المضافة",
      registeredAddress: "العنوان المسجل*",
      middleName: "الاسم الأوسط",
      middleNameLabel: "الاسم الأوسط",
      enterMiddleName: "أدخل الاسم الأوسط",
      tradingAddress: "عنوان النشاط التجاري*",
      sameAsRegisteredAddress: "كما هو العنوان المسجل",
      billingInformation: "معلومات الفوترة",
      billingPhoneNo: "رقم هاتف الفوترة*",
      phonePlaceholder: "أدخل رقم الهاتف",
      billingEmail: "البريد الإلكتروني للفوترة*",
      emailPlaceholder: "أدخل بريد الفوترة الإلكتروني",
      driverDetails: "تفاصيل السائق",
      customerVerificationStatus: "حالة التحقق من العميل",
      enterNationalInsuranceNumber: "أدخل رقم التأمين الوطني",
      enterYourProfession: "أدخل مهنتك",
      enterDriving: "أدخل رخصة القيادة",
      profileImage: "صورة الملف الشخصي",
      number: "الرقم",
      image: "صورة",
      uploadBack: "تحميل الخلفي",
      uploadFront: "تحميل الأمامي",
      issuedBy: "صادر عن",
      document: "وثيقة",
      selectDocument: "اختر المستند",
      addFile: "أضف ملف",
      noDataFound: "لم يتم العثور على بيانات",
      noDocumentsFound: "لم يتم العثور على مستندات",
      documentUpdatedAt: "تم تحديث المستند في",
      editExpiryDate: "تحرير تاريخ الانتهاء",
      selectExpiryDate: "اختر تاريخ الانتهاء",
      selectExpiryDateUpload: "يرجى اختيار تاريخ انتهاء قبل التحميل.",
      status: "الحالة",
      images: "الصور",
      profession: "المهنة",
      nationality: "جنسية",
      driving: "رخصة القيادة",
      listOfDocumentsUploaded: "قائمة المستندات المرفوعة",
      listOfRequiredDocumentsUploaded: "قائمة المستندات المطلوبة المرفوعة",
      documentType: "نوع المستند",
      documentName: "اسم المستند",
      expiryDate: "تاريخ الانتهاء",
      confirmDelete: "تأكيد الحذف",
      actions: "الإجراءات",
      completed: "مكتمل",
      pending: "قيد الانتظار",
      documentDeleteConfirmMsg: "هل أنت متأكد أنك تريد حذف هذا المستند؟",
      address: "العنوان",
      useRegisteredAddress: "استخدم العنوان المسجل",
      billingEmailAddress: "البريد الإلكتروني للفوترة*",
      billingEmailLabel: "عنوان البريد الإلكتروني للفوترة",
      accountNumber: "رقم الحساب",
      firstName: "الاسم الأول*",
      lastName: "اسم العائلة*",
      firstNameLabel: "الاسم الأول",
      lastNameLabel: "اسم العائلة",
      contactEmail: "بريد الاتصال الإلكتروني*",
      emailLabel: "عنوان البريد الإلكتروني",
      contactPhone: "رقم هاتف الاتصال*",
      registeredAddressCaps: "العنوان المسجل",
      tradingAddressCaps: "عنوان النشاط التجاري",
      billingInformationCaps: "معلومات الفوترة",
      customerContactCaps: "جهة اتصال العميل",
      contactEmailInvalid: "يرجى إدخال بريد إلكتروني صالح.",
      typeAddress: "اكتب العنوان",
      taxFees: "الضرائب والرسوم",
      vatTax: "الضريبة/القيمة المضافة",
      registrationNum: "رقم التسجيل",
      drivingLicenceNumber: "رقم رخصة القيادة",
      invalidPhoneNumber: "رقم هاتف غير صالح",
      onStartEmail: "لقد أرسلنا إليك بريدًا إلكترونيًا بكيفية البدء.",
      emailNotSeen:
        'إذا لم ترَ البريد الإلكتروني خلال دقائق، تحقق من مجلد "الرسائل غير المرغوب فيها".',
      registerNow: "سجل الآن",
      email: "البريد الإلكتروني",
      thankYou: "شكرًا لك",
      pickUpLocation: "موقع الاستلام",
      returnLocation: "موقع الإرجاع *",
      pickUpDate: "تاريخ الاستلام *",
      pickUpTime: "وقت الاستلام *",
      invalidPickupLeadTime: "تاريخ/وقت الاستلام المحدد خارج نافذة الحجز المسموح بها",
      dropOffDate: "تاريخ التسليم *",
      searchVehicles: "ابحث عن المركبات",
      chooseLocation: "أدخل الموقع أو الرمز البريدي",
      vehicleGallery: "معرض المركبات",
      privacyPolicy: "سياسة الخصوصية",
      termsAndConditions: "الشروط والأحكام",
      dropOffTime: "وقت التسليم *",
      noVehiclesFound: "لم يتم العثور على مركبات تطابق المعايير المحددة",
      noRecordFound: "عذرًا، لم يتم العثور على سجلات مطابقة!",
      vehicles: "المركبات",
      endDate: "تاريخ الانتهاء",
      startDate: "تاريخ البدء",
      past: "سابق",
      search: "بحث",
      upcoming: "قادم",
      current: "الحالي",
      all: "الكل",
      more: "المزيد",
      toBeAssigned: "سيتم التعيين",
      ref: "مرجع",
      reservation: "الحجز",
      booking: "الحجز",
      pricingSummary: "ملخص التسعير",
      bookingSummary: "ملخص الحجز",
      subscriptionVehicle: "مركبة الاشتراك",
      insurance: "التأمين",
      addons: "الإضافات",
      protectionPlan: "خطة الحماية",
      initialRental: "الدفعة الأولية للإيجار",
      enrollmentFee: "رسوم التسجيل",
      quantity: "الكمية",
      subscriptionPrice: "سعر الاشتراك",
      weekly: "أسبوعي",
      monthly: "شهري",
      on: "في",
      numberOfDoors: "عدد الأبواب",
      numberOfSeats: "عدد المقاعد",
      transmission: "ناقل الحركة",
      fuelType: "نوع الوقود",
      week: "أسبوع",
      day: "يوم",
      hour: "ساعة",
      month: "شهر",
      gropu1Icon: "أيقونة المجموعة 1",
      vatInclusive: "شامل ضريبة القيمة المضافة",
      vat: "ضريبة القيمة المضافة",
      rental: "الإيجار",
      speedometer: "عداد السرعة",
      available: "متاح",
      priceLowToHigh: "السعر من الأقل إلى الأعلى",
      priceHighToLow: "السعر من الأعلى إلى الأقل",
      weHaveSmartCars: "لدينا سيارات ذكية",
      keylessSupport: "نوفر دعم دخول بدون مفتاح لسياراتنا الذكية",
      keylessVehicles: "عرض المركبات بدون مفتاح",
      duration: "المدة",
      swapsAllowed: "التبديل مسموح",
      enrollmentAmount: "مبلغ التسجيل",
      subscriptionAmount: "مبلغ الاشتراك",
      mileageLimit: "حد الأميال",
      unlimited: "غير محدود",
      weeks: "أسابيع",
      months: "أشهر",
      pricePerExtraMile: "السعر لكل ميل إضافي",
      insurancePolicy: "وثيقة التأمين",
      removeSubscription: "إلغاء الاشتراك",
      noGroupFound: "لم يتم العثور على مجموعات مطابقة!",
      vehicleTypeIcon: "أيقونة نوع المركبة",
      min: "الحد الأدنى",
      selected: "محدد",
      vehiclesSelected: "المركبات المحددة",
      selectVehicles: "اختر المركبات",
      personalDetails: "البيانات الشخصية",
      selectAddons: "اختر الإضافات",
      continue: "استمرار",
      locationSurcharge: "رسوم الموقع الإضافية",
      onTotalRentalAmount: "على إجمالي مبلغ الإيجار",
      oneWayFee: "رسوم الاتجاه الواحد",
      oneWayRentalCharge: "رسوم الإيجار باتجاه واحد",
      total: "الإجمالي",
      firstMonthTotal: "إجمالي الشهر الأول",
      firstWeekTotal: "إجمالي الأسبوع الأول",
      depositPayable: "الوديعة (تدفع عند الاستلام)",
      deposit: "الوديعة",
      insuranceCaps: "التأمين",
      customAddon: "إضافة مخصصة",
      chooseAPolicy: "اختر سياسة",
      rate: "السعر",
      typeOfValet: "نوع خدمة التوصيل",
      nonNegotiable: "غير قابل للتفاوض",
      selectValet: "اختر خدمة التوصيل",
      collectionAddress: "عنوان الاستلام",
      remove: "إزالة",
      deliveryAddress: "عنوان التسليم",
      additionalInformation: "معلومات إضافية",
      confirmBooking: "تأكيد الحجز",
      proceed: "متابعة",
      getQuote: "احصل على عرض سعر",
      for: "لـ",
      agreeWithTermsAndConditions: "أوافق على الشروط والأحكام",
      selectCostCenter: "اختر مركز تكلفة للحجز",
      action: "الإجراء",
      name: "الاسم",
      enterDrivingLicenceNumber: "أدخل رقم رخصة القيادة",
      enterLastName: "أدخل اسم العائلة",
      enterFirstName: "أدخل الاسم الأول",
      enterYourMail: "أدخل بريدك الإلكتروني",
      emailAsterisk: "البريد الإلكتروني*",
      quoteGeneratedCaps: "تم إنشاء عرض السعر",
      updated: "تم التحديث",
      rentalCharges: "رسوم الإيجار",
      totalPayableAmount: "إجمالي المبلغ المستحق",
      payMinimumAmount: "دفع الحد الأدنى",
      dueAmountPaidWhilePickup: "المبلغ المستحق يُدفع عند الاستلام",
      payOnCollection: "الدفع عند الاستلام",
      CardAuthorization: "سيتم تفويض البطاقة الآن ولكن لن يُخصم المبلغ إلا عند",
      starts: "البدء",
      confirm: "تأكيد",
      payAtTimeOfPickup: "الآن والدفع عند الاستلام",
      payFullAmountNow: "ادفع المبلغ الكامل الآن",
      payFullAmountRightAway: "ادفع المبلغ الكامل فورًا",
      FutureChargesRelatedToOngoingBooking:
        "سيتم خصم الرسوم المستقبلية المرتبطة بالحجز الجاري من طريقة الدفع هذه",
      saveThisCardForFutureInvoices:
        "احفظ هذه البطاقة لدفع الفواتير المستقبلية لـ {{bookingSyntax}}",
      payLater: "ادفع لاحقًا",
      creditLimitAssigned: "سيتم استخدام حد الائتمان المخصص لهذا العمل للدفع",
      CreditsAgainstBooking: "سيتم استخدام الرصيد مقابل هذا الحجز",
      useCreditNoteBalance: "استخدم رصيد إشعار الائتمان",
      telNo: "رقم الهاتف",
      vatNo: "رقم ضريبة القيمة المضافة",
      customer: "العميل",
      emailAddress: "عنوان البريد الإلكتروني",
      phoneNumber: "رقم الهاتف",
      dateCreated: "تاريخ الإنشاء",
      poNumber: "رقم أمر الشراء",
      dateTime: "التاريخ والوقت",
      dropOffLocation: "موقع التسليم",
      contractHire: "تأجير تعاقدي",
      subscription: "اشتراك",
      charges: "الرسوم",
      enrollmentFees: "رسوم التسجيل",
      na: "غير متاح",
      grandTotal: "الإجمالي النهائي",
      rentalPrice: "سعر الإيجار",
      daysProRated: "أيام محسوبة بنسبة",
      locationSurcharges: "الرسوم الإضافية للموقع",
      ofTotalRentalAmount: "من إجمالي مبلغ الإيجار",
      nextBilling: "الفاتورة التالية",
      subTotal: "المجموع الفرعي",
      discount: "الخصم",
      discountedPrice: "السعر المخفض",
      description: "الوصف",
      descriptionLabel: "الوصف",
      thisIsA: "هذا هو",
      exemptedBooking: "حجز مُعفى",
      thisIstestCourtsey: "هذا حجز تجريبي / مجاملة",
      isCalculatedAgainst: "يتم حسابه مقابل",
      priceAndSelectedAddons:
        "السعر وبعض الإضافات المختارة باستثناء التأمين والوديعة",
      recurringWeeklyMonthlyInvoice:
        "سيتم إنشاء فاتورة أسبوعية / شهرية متكررة تلقائيًا للأسبوع / الشهر التالي.",
      additionalNote: "ملاحظة إضافية",
      payableAtVehicleCollection: "يُدفع عند استلام المركبة",
      purchaseOrderUpdated: "تم تحديث رقم أمر الشراء بنجاح",
      proceedToPay: "المتابعة للدفع",
      searchResults: "نتائج البحث",
      subscriptions: "الاشتراكات",
      contractHireVehicleWeeklyMonthly: "تأجير تعاقدي أسبوعي / شهري للمركبة",
      subscribeVehicleWeeklyMonthly: "اشترك في المركبة أسبوعيًا / شهريًا",
      contractNow: "أبرم العقد الآن",
      subscribeNow: "اشترك الآن",
      backToBookingCategorySelection: "العودة إلى اختيار فئة الحجز",
      accountVerification: "التحقق من الحساب",
      profileNotVerifiedMessage:
        "لم يتم التحقق من ملفك الشخصي. يرجى التواصل مع المشغل لإتمام عملية التحقق من الحساب والمتابعة.",
      update: "تحديث",
      reference: "مرجع",
      companyRegistrationNumber: "رقم تسجيل الشركة",
      availableFrom: "متوفر من",
      paellaDish: "طبق باييلا",
      vehicleCatalogues: "كتالوجات المركبات",
      vehicleDetails: "تفاصيل المركبة",
      verification: "التحقق",
      protectionPlans: "خطط الحماية",
      authorisedSignatory: "المخول بالتوقيع",
      item: "العنصر",
      price: "السعر",
      unitPrice: "سعر الوحدة",
      vehicleSpecification: "مواصفات المركبة",
      model: "الموديل",
      color: "اللون",
      bodyType: "نوع الهيكل",
      tankCapacity: "سعة الخزان",
      interiorColor: "لون الداخل",
      seats: "المقاعد",
      doors: "الأبواب",
      whatsIncluded: "المُدرج",
      timeVehicleSwap: "موعد تبادل المركبة",
      contractualDetails: "تفاصيل العقد",
      longerSubscribeSaveMore: "كلما طالت مدة الاشتراك يمكنك توفير أكثر",
      tailorSubscriptionToNeeds: "فصّل اشتراكك حسب احتياجاتك",
      easyManagementOnline: "إدارة سلسة وسهلة عبر الإنترنت",
      SwapCarAndCancel: "بدّل مركبتك أو ألغِ في أي وقت",
      customizeYourContract: "خصص عقدك",
      selectPlan: "اختر الخطة",
      selectTenure: "حدد المدة",
      tentativeStartDate: "تاريخ بدء مبدئي",
      selectDate: "اختر التاريخ",
      selectTime: "اختر الوقت",
      contractSummary: "ملخص عقدك",
      subscriptionChargesLabel: "رسوم الاشتراك",
      initialRentalPayment: "دفعة الإيجار الأولية",
      continueToPersonalDetails: "تابع إلى البيانات الشخصية",
      noAvailableAddonsFound:
        "لم يتم العثور على إضافات متوفرة تتناسب مع معايير البحث",
      nationalInsuranceNumber: "رقم التأمين الوطني",
      updateQuote: "تحديث العرض",
      driverNotAvailable: "السائق غير متاح، يرجى الاتصال بمشغل الإيجار",
      selectDeliverySlot: "اختر فترة التوصيل",
      wantDelivered: "هل ترغب أن يتم التوصيل؟",
      verifyYourLicenceCaps: "تحقق من رخصتك",
      validateAllFieldsForLicenceCheck:
        "يرجى التحقق أو إدخال التفاصيل التالية للمتابعة بفحص الرخصة. جميع الحقول إلزامية",
      postCode: "الرمز البريدي",
      thisAgreementAllows: "يتيح هذا الاتفاق",
      leftoverAgreement:
        "وشريك التأمين الخاص بنا لاتخاذ الإجراءات اللازمة بفحص رخصة القيادة وتمرير البيانات المزودة منك إلى شركات التأمين وأطراف ثالثة ذات صلة (Coastr) لإدارة استئجار المركبة، وثيقة التأمين، إلخ. هل تقبل وتوافق على ما سبق؟",
      verifyLicence: "تحقق من الرخصة",
      licenceCheckingInProgress: "جارٍ فحص الرخصة",
      checkingInProgress:
        "قد يستغرق الأمر حتى دقيقتين، يرجى الانتظار وعدم إعادة تحميل أو إغلاق المتصفح",
      licenceCheckingFailed: "فشل فحص الرخصة",
      checkForCorrectDetails: "يرجى التحقق من صحة البيانات المدخلة.",
      tryAgainLater: "إذا استمرت المشكلة، يرجى المحاولة مرة أخرى لاحقًا.",
      licenceCheckedSuccessfully: "تم فحص الرخصة بنجاح",
      licenceSummaryAdded: "تمت إضافة ملخص الرخصة إلى سجل العميل",
      creditScore: "الدرجة الائتمانية",
      lastChecked: "آخر فحص",
      recheckCreditScore: "إعادة فحص الدرجة الائتمانية",
      checkCreditScore: "فحص الدرجة الائتمانية",
      proceedToPayment: "المتابعة إلى الدفع",
      paymentOverview: "نظرة عامة على الدفع",
      schedule: "الجدول",
      contractDetails: "تفاصيل العقد",
      plan: "الخطة",
      swaps: "التبديلات",
      payableDeposit: "الوديعة المستحقة",
      customerVerification: "التحقق من العميل",
      provideAdditionalDetails:
        "يرجى تقديم التفاصيل الإضافية التالية ضمن قسم الحساب لإنشاء الحجز",
      profilePhoto: "صورة الملف الشخصي",
      submitYourRequest:
        "بمجرد الانتهاء، يرجى إرسال طلبك للموافقة عبر الضغط على زر إرسال أدناه",
      submit: "إرسال",
      uploadLicenceImages: "تحميل صور الرخصة",
      add: "إضافة",
      uploadFrontBackLicence:
        "تحميل وجه وخلف الرخصة. الصيغ المدعومة: .png, .jpeg, .jpg!",
      uploadLicenceImage: "تحميل صورة الرخصة",
      authority: "الجهة المصدرة",
      drivingLicenceExpiryDate: "تاريخ انتهاء رخصة القيادة",
      licenceNumber: "رقم الرخصة",
      preview: "معاينة",
      addOn: "إضافة",
      contact: "جهة الاتصال",

      selectSlot: "اختر الفترة",
      deliveryType: "نوع التوصيل",
      experience: "التجربة",
      type: "النوع",
      bookATestDrive: "احجز تجربة قيادة",
      selectASlot: "اختر فترة",
      selectDateTimeSlot: "اختر التاريخ والفترة الزمنية",
      vehicleNotAvailable: "المركبة غير متاحة للتاريخ المحدد",
      selectDifferentDate: "يرجى اختيار تاريخ مختلف",
      selectCar: "اختر سيارة",
      availableNow: "متاح الآن",
      new: "جديد",
      phone: "الهاتف",
      customerDetails: "تفاصيل العميل",
      dealershipAddress: "عنوان الوكالة",
      dealership: "الوكالة",
      bookingTime: "وقت الحجز",
      bookingType: "نوع الحجز",
      details: "التفاصيل",
      your: "الخاصة بك",
      confirmation: "تأكيد",
      selectDealership: "اختر وكالة",
      testDriveRequested: "تم طلب تجربة قيادة",
      testDrive: "تجربة القيادة",
      mobileNumber: "رقم الجوال",
      drivingLicenseNumber: "رقم رخصة القيادة",
      enterLicenseNumber: "أدخل رقم الرخصة",
      requestTestDrive: "طلب تجربة قيادة",
      slot: "الفترة",
      vehicle: "المركبة",

      selectSubsctiption: "اختر الاشتراك",
      pricesShownOnSelectedDuration: "الأسعار معروضة بناءً على المدة المحددة",
      priceComparison: "مقارنة الأسعار",
      oneTime: "مرة واحدة",
      subscriptionStartsAt: "يبدأ الاشتراك في",
      paymentProcessing: "جارٍ معالجة الدفع",
      pleaseWait: "يرجى الانتظار",
      paymentComplete: "اكتمل الدفع",
      paymentInProgress: "جارٍ الدفع",
      atleastUploadOne: "يجب تحميل واحدة على الأقل",
      upload: "تحميل",
      uploadServiceNotAvailable: "خدمة التحميل غير متوفرة. يرجى المحاولة مرة أخرى.",
      uploading: "جارٍ التحميل...",
      atDealership: "في الوكالة",
      atHome: "في المنزل",

      enterYourEmailPassword:
        "أدخل بريدك الإلكتروني وكلمة المرور لتسجيل الدخول",
      enterMailHere: "أدخل بريدك هنا",
      required: "مطلوب",
      password: "كلمة المرور",
      reset: "إعادة تعيين",
      otpForPasswordReset:
        "ستتلقى رمز تأكيد لإعادة تعيين كلمة المرور عبر بريدك الإلكتروني",
      sendOtp: "إرسال الرمز",
      loginInstead: "تسجيل الدخول بدلاً من ذلك",
      verifyOtp: "تحقق من الرمز",
      otp: "الرمز",
      otpSentToEmail: "تم إرسال الرمز إلى بريدك الإلكتروني",
      enterOtp: "أدخل الرمز",
      enterOtpHere: "أدخل الرمز هنا",
      verify: "تحقق",
      setNewPassword: "قم بتعيين كلمة مرور جديدة",
      eightCharLong: "يجب أن تكون 8 أحرف على الأقل",
      reenterPassword: "أعد إدخال كلمة المرور هنا",

      signInAs: "تسجيل الدخول كـ",
      as: "بصفتك",
      selectAccountToProceed: "اختر حسابًا للمتابعة",
      personalAccount: "حساب شخصي",
      asBusinessCustomer: "كعميل مؤسسة",
      asDriver: "كسائق",
      enterPassword: "أدخل كلمة المرور هنا",
      registerAs: "سجل كـ",
      individual: "فرد",
      business: "مؤسسة",
      operatorMandatedCustomerCheck:
        "المشغل يطلب التحقق من العميل قبل تأكيد الحجز. يرجى الانتظار للموافقة.",
      createAccount: "إنشاء حساب",
      emailedHowToGetStarted: "أرسلنا لك بريدًا إلكترونيًا يوضح كيفية البدء.",
      ifDontSeeEmail:
        "إذا لم يظهر البريد في دقائق، تحقق مجلد الرسائل غير المرغوب فيها.",

      previousVehicleDetails: "تفاصيل السيارة السابقة",
      registration: "التسجيل",
      makeModel: "الماركة/الموديل",
      vin: "رقم الهيكل",
      driverAssigned: "تم تعيين سائق",
      currentVehicleDetails: "تفاصيل المركبة الحالية",
      priceGroup: "فئة السعر",
      unlimitedMileage: "أميال غير محدودة",
      paymentStatus: "حالة الدفع",

      invoiceNumber: "رقم الفاتورة",
      deliveryDetails: "تفاصيل التسليم",
      collectionDetails: "تفاصيل الاستلام",
      coiDetails: "تفاصيل بوليصة التأمين",
      policyName: "اسم البوليصة",
      planName: "اسم الخطة",
      policyNumber: "رقم البوليصة",
      provider: "المزود",

      vehicleSwapDetails: "تفاصيل تبديل المركبة",
      swapMyCar: "بدّل سيارتي",
      NoOfSwapsAllowed: "عدد التبديلات المسموح بها",
      NoOfSwapsAvailed: "عدد التبديلات المستخدمة",
      NoOfSwapsRemaining: "عدد التبديلات المتبقية",
      swapRequestHistory: "سجل طلبات التبديل",
      requestedOn: "تم الطلب في",
      swapDate: "تاريخ التبديل",
      oldVehicle: "المركبة القديمة",
      newVehicle: "المركبة الجديدة",
      addonsDetails: "تفاصيل الإضافات",
      paymentDetails: "تفاصيل الدفع",
      billingPeriod: "فترة الفوترة",
      creationDate: "تاريخ الإنشاء",

      invoiceType: "نوع الفاتورة",
      regular: "عادية",
      depositDetails: "تفاصيل الوديعة",
      amount: "المبلغ",
      totalPaidAmount: "إجمالي المبلغ المدفوع",
      cancellationCharges: "رسوم الإلغاء",
      totalRefundAmount: "إجمالي مبلغ الاسترداد",
      anUnpaid: "غير مدفوعة",
      aPartiallyPaid: "مدفوعة جزئيًا",
      thisIs: "هذا هو",
      pleaseContactUs: "يرجى التواصل معنا لمزيد من الاستفسارات",
      reasonToCancelTheBooking: "يرجى تحديد سبب إلغاء الحجز",
      enterTheReason: "أدخل السبب",
      dismiss: "رفض",

      selectVehicle: "اختر مركبة",
      bookingConfirmationInProgress: "جارٍ تأكيد الحجز",
      pleaseProvideTheReason: "يرجى تقديم السبب",
      quote: "عرض السعر",
      management: "الإدارة",
      pickupDateTimePassed: "تاريخ/وقت الاستلام قد مضى أو أنه حجز بدون رسوم",
      profileRejectedOrPending: "ملفك مرفوض أو قيد الانتظار",
      testDriveAgreement: "اتفاقية تجربة القيادة",
      rentalAgreement: "عقد الإيجار",
      contractHireAgreement: "عقد الإيجار التعاقدي",
      subscriptionAgreement: "عقد الاشتراك",

      zeroChargeBooking: "الحجز بدون رسوم يمكن تأكيده فقط بواسطة مشغل الإيجار",
      pickupDateTimeInPast: "تاريخ/وقت الاستلام في الماضي",
      creditNoteSummary: "ملخص إشعار الائتمان",
      customerName: "اسم العميل",
      customerEmail: "بريد العميل الإلكتروني",
      creditNoteRef: "مرجع إشعار الائتمان",
      invoiceRef: "مرجع الفاتورة",

      totalAmount: "المبلغ الإجمالي",
      amountAdjustedRefunded: "المبلغ المعدل/المسترد",
      amountAvailable: "المبلغ المتاح",
      adjustments: "التعديلات",
      particulars: "تفاصيل",
      adjustedToInvoice: "تم تعديله للفاتورة",
      adjustedAt: "تم التعديل في",
      creditNotes: "إشعارات الائتمان",
      availableBalance: "الرصيد المتاح",
      searchCreditNoteId: "ابحث عن رقم إشعار الائتمان",

      active: "نشيط",
      exhausted: "مستهلك",
      creditNoteId: "رقم إشعار الائتمان",
      dateGenerated: "تاريخ الإصد",

      amountRefunded: "المبلغ المسترد",
      amountRemaining: "المبلغ المتبقي",
      dashboard: "لوحة التحكم",
      activeVehiclesCount: "عدد المركبات النشطة",
      totalActiveBookings: "إجمالي الحجوزات النشطة",
      totalVehicles: "إجمالي المركبات",
      vehicleChecks: "فحوصات المركبة",
      inProgressBookings: "الحجوزات الجارية",
      vehicleChecksCompleted: "فحوصات المركبة المكتملة",
      vehicleChecksPending: "فحوصات المركبة المعلقة",
      dailyBalance: "الرصيد اليومي",
      totalOutstanding: "إجمالي المبالغ المستحقة",
      UnpaidInvoices: "عدد الفواتير غير المدفوعة",
      regularInvoices: "الفواتير العادية",
      sundryInvoices: "الفواتير المتنوعة",
      addNewDriver: "إضافة سائق جديد",
      phoneNo: "رقم الهاتف",
      drivingLicenceImage: "صورة رخصة القيادة",
      licenceIssuedBy: "الرخصة صادرة عن",
      licenceExpiryDate: "تاريخ انتهاء الرخصة",
      drivingLicenceIssueDate: "تاريخ إصدار رخصة القيادة",
      pcoIssueDate: "تاريخ إصدار رخصة السائق PCO",
      dateOfBirth: "تاريخ الميلاد",
      taskDetailsNotFound: "تفاصيل المهمة غير موجودة",
      bookingRef: "مرجع الحجز",
      rateYourExperience: "قيّم تجربتك",
      driverInformation: "معلومات السائق",
      saveDrivers: "حفظ السائقين",
      expiry: "انتهاء",
      areYouSureDriver: "هل أنت متأكد أنك تريد إزالة هذا السائق من",
      drivers: "السائقون",
      noDriverFound: "عذرًا، لم يتم العثور على سائقين!",
      invoices: "الفواتير",
      searchInvoiceId: "ابحث عن رقم الفاتورة",
      unpaid: "غير مدفوعة",
      paid: "مدفوعة",
      void: "ملغاة",
      invoiceId: "رقم الفاتورة",
      invoiceDate: "تاريخ الفاتورة",
      balanceDue: "الرصيد المستحق",
      dueDate: "تاريخ الاستحقاق",
      invoiceSummary: "ملخص الفاتورة",
      invoice: "فاتورة",
      sundry: "متنوع",
      addPayment: "إضافة دفعة",
      customerPhoneNumber: "رقم جوال العميل",
      invoiceReference: "مرجع الفاتورة",
      period: "الفترة",
      invoiceVoidedBy: "تم إلغاء الفاتورة بواسطة",
      invoicePeriod: "مدة الفاتورة",
      invoiceStatus: "حالة الفاتورة",
      invoiceAmount: "مبلغ الفاتورة",
      amountDue: "المبلغ المستحق",
      generatedAt: "تم إنشاؤها في",
      vehicleRentalCharges: "رسوم تأجير المركبة",
      refundable: "قابل للاسترداد",
      date: "التاريخ",
      thisIsTestCourtsey: "هذا حجز تجريبي/مجاني",
      invoicesConsolidated: "الفواتير الموحدة",
      payments: "المدفوعات",
      exempted: "معفي",
      pleaseLoginFirst: "يرجى تسجيل الدخول أولاً",
      account: "الحساب",
      tracking: "التتبع",
      uploadImages: "تحميل الصور",
      updateVehicleState: "تحديث حالة المركبة",
      vehicleImage: "صورة المركبة",
      fuelStatus: "حالة الوقود",
      batteryStatus: "حالة البطارية",
      odometerReading: "قراءة العداد",
      nextServiceDetails: "تفاصيل الخدمة القادمة",
      serviceType: "نوع الخدمة",
      serviceStatus: "حالة الخدمة",
      appointmentDate: "تاريخ الموعد",
      estdCompletionDate: "تاريخ الإكمال المتوقع",
      serviceProviderName: "اسم مزود الخدمة",
      serviceProviderAddress: "عنوان مزود الخدمة",
      notesForDriver: "ملاحظات للسائق",
      exteriorDamages: "الأضرار الخارجية",
      interiorDamages: "الأضرار الداخلية",
      generalChecks: "الفحوصات العامة",
      accessoriesChecks: "فحوصات الملحقات",
      chooseFuelLevel: "اختر مستوى الوقود",
      lastReported: "آخر تقرير",
      circumstance: "الظرف",
      title: "العنوان",
      damageKind: "نوع الضرر",
      damageArea: "منطقة الضرر",
      referenceNumber: "رقم المرجع",
      damageDetail: "تفاصيل الضرر",
      addImage: "إضافة صورة",
      addImages: "إضافة صور",
      done: "تم",
      searchExistingDriver: "ابحث عن سائق موجود",
      success: "نجاح",
      assignDriver: "تعيين سائق",
      plate: "رقم اللوحة",
      unassigned: "غير معين",
      assigned: "معين",
      make: "الماركة",
      vehicleAppearOnceAssigned: "ستظهر المركبات بمجرد تعيينها لك!",
      searchVehicle: "ابحث عن مركبة",
      trackingHistoryHrs: "سجل التتبع (بالساعات)",
      telemetryDevice: "جهاز القياس عن بعد",
      lastLocation: "الموقع الأخير",
      latitude: "خط العرض",
      longitude: "خط الطول",
      forSelectedPeriod: "للفترة المحددة -",
      milesDriven: "الأميال المقطوعة",
      engineHours: "ساعات المحرك",
      fuelUsageLitres: "استهلاك الوقود (لتر)",
      stoppagehours: "ساعات التوقف",
      chargeStatus: "حالة الشحن",
      fuelUsage: "استهلاك الوقود",
      batteryLevel: "مستوى البطارية",
      speedLimit: "حد السرعة",
      invalidEmailAddress: "عنوان بريد إلكتروني غير صالح",
      unableLoadCompanyDetails: "غير قادر على تحميل بيانات الشركة",
      bookingConfirmationProgress: "جارٍ تأكيد الحجز...",
      doNotHitBack:
        "يرجى عدم الضغط على رجوع أو إيقاف أو إغلاق المتصفح. قد يستغرق هذا العملية حتى دقيقتين.",
      summary: "الملخص",
      addNew: "إضافة جديدة",
      street: "الشارع",
      city: "المدينة",
      regionState: "المنطقة/الولاية",
      country: "البلد",
      zipPostalCode: "الرمز البريدي",
      cardAuthorizeNowButAmountLater:
        "سيتم تفويض البطاقة الآن لكن يسحب المبلغ عند بدء الحجز",
      saveThisCardForFutureInvoicesBooking:
        "احفظ هذه البطاقة للدفع على الفواتير المستقبلية لهذا الحجز.",
      confirmBookingPayLater: "تأكيد الحجز، الدفع لاحقًا",
      confirmBookingAndPayAtPickup: "تأكيد الحجز الآن والدفع عند الاستلام",
      bookingReferenceNumber: "رقم مرجع الحجز",
      pickupDetails: "تفاصيل الاستلام",
      dropoffDetails: "تفاصيل التسليم",
      to: "إلى",
      bookingReference: "مرجع الحجز",
      invoiceStartDate: "تاريخ بدء الفاتورة:",
      invoiceEndDate: "تاريخ نهاية الفاتورة:",
      availableAtLocations: "متاح في المواقع",
      benefits: "الفوائد",
      passportNumber: "رقم جواز السفر",
      enterPassportNumber: "أدخل رقم جواز السفر",
      vehicleSwapRequest: "طلب تبديل المركبة",
      checkVehicleAvailability: "تحقق من توفر المركبة",
      pleaseSelectDateAndSearch:
        "يرجى اختيار تاريخ والضغط على بحث لتوفر المركبة",
      noVehicleFoundForSelectedDate: "لم يتم العثور على مركبة للتاريخ المحدد",
      notes: "ملاحظات",
      writeYourNoteHere: "اكتب ملاحظتك هنا",
      updateRequest: "تحديث الطلب",
      generateRequest: "إنشاء الطلب",
      cancelRequest: "إلغاء الطلب",
      operator: "المشغل",
      you: "أنت",
      maximum: "الحد الأقصى",
      imagesAreAllowed: "يسمح بتحميل الصور.",
      dragAndDropFile: "اسحب الملف أو اضغط هنا",
      areAllowed: "مسموح بها",
      cancelBooking: "إلغاء الحجز",
      booked: "تم الحجز",
      organisation: "المنظمة",
      vatNumber: "رقم ضريبة القيمة المضافة",
      sort: "ترتيب",
      DELETE_DRIVER_DESCRIPTION: "هل أنت متأكد أنك تريد حذف السائق؟",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "هل أنت متأكد أنك تريد حذف السائق؟",
        "Delete Driver": "حذف السائق",
      },
      currentInvoiceStatus: {
        PAID: "مدفوع",
        UNPAID: "غير مدفوع",
        VOID: "ملغي",
        "PARTIALLY PAID": "مدفوع جزئيًا",
        DRAFT: "مسودة",
      },
      currentBookingStatus: {
        CANCELLED: "تم الإلغاء",
        COMPLETED: "مكتمل",
        "CONFIRMATION IN PROCESS": "تأكيد قيد المعالجة",
        CONFIRMED: "تم التأكيد",
        "IN PROGRESS": "قيد التنفيذ",
        QUOTE: "عرض سعر",
        DRAFT: "مسودة",
        "REQUIRES APPROVAL": "يتطلب موافقة",
        DECLINED: "مرفوض",
      },
      minBookingDurationMessage:
        "الحد الأدنى لمدة الحجز هو {{hours}} ساعة. يرجى تعديل تاريخ ووقت الاستلام أو الإرجاع وفقًا لذلك.",
      maxBookingDurationMessage:
        "الحد الأقصى لمدة الحجز هو {{days}} يومًا. يرجى تعديل تاريخ ووقت الاستلام أو الإرجاع وفقًا لذلك.",
      usevaletTypes: {
        Delivery: "توصيل",
        Collection: "استلام",
        "Delivery and Collection": "توصيل واستلام",
      },
      selectCollectionSlot: "اختر فترة الاستلام",
      driverUnavailableNote:
        "ملاحظة: السائق غير متوفر، يرجى التواصل مع مشغل التأجير.",
      cancellationReasons: {
        "Requirement changed": "تغيرت المتطلبات",
        Price: "السعر",
        Other: "أخرى",
      },
      imagePreview: "معاينة الصورة",
      markDamage: "وضع علامة على الضرر",
      vehicleDamageImages: "صور أضرار المركبة",
      incidentDate: "تاريخ الحادث",
      incidentTime: "وقت الحادث",
      clear: "مسح",
      bookingStatus: "حالة الحجز",
      daysInBooking: "أيام في الحجز",
      accumulatedDays: "الأيام المتراكمة",
      endingThisMonth: "تنتهي هذا الشهر",
      creditUtilisation: "استخدام الائتمان",
      creditLimit: "حد الائتمان",
      utilized: "تستخدم",
      totalDrivers: "إجمالي السائقين",
      vehiclesAllocated: "المركبات المخصصة",
      mileageOverview: "نظرة عامة على الأميال",
      mileageLimitExited: "حد الأميال خرج",
      approachingMileageLimits: "تقترب من حدود الأميال",
      motReminders: "تذكيرات MOT",
      totalMotTests: "اختبارات MOT الكلية",
      healthCheckReminders: "تذكيرات الفحص الصحي",
      totalHealthCheckTests: "إجمالي اختبارات الفحص الصحي" ,
      failed: "فشل",
      serviceReminders: "تذكيرات الخدمة",
      overdue: "تأخر",
      totalServiceReminders: "إجمالي تذكيرات الخدمة",
      createNewServiceRequest: "إنشاء طلب خدمة جديد",
      serviceDetails: "تفاصيل الخدمة",
      selectedVehicle: "المركبة المختارة",
      serviceRequestSelectVehicle: "اختر المركبة",
      loadingVehicles: "جارٍ تحميل المركبات...",
      noActiveVehiclesFound: "لم يتم العثور على مركبات نشطة",
      addDetails: "إضافة تفاصيل",
      addItems: "إضافة عناصر",
      issueType: "نوع المشكلة",
      issueTypePlaceholder: "مثل، قفل مكسور",
      descriptionPlaceholder: "مثل، قفل الباب الأمامي الأيسر",
      uploaded: "تم التحميل",
      additionalComments: "تعليقات إضافية",
      additionalCommentsPlaceholder: "أضف أي معلومات إضافية...",
      submitting: "جارٍ الإرسال...",
      submitRequest: "إرسال الطلب",
      serviceRequestNote: "سيتم مراجعة طلبك من قبل فريق الخدمة لدينا. ستتلقى إشعارًا بمجرد الموافقة عليه أو إذا كانت هناك حاجة إلى معلومات إضافية.",
      serviceRequestDetails: "تفاصيل طلب الخدمة",
      createdDate: "تاريخ الإنشاء",
      estimatedCost: "التكلفة المقدرة",
      requestProgress: "تقدم الطلب",
      issuesReported: "المشاكل المبلغ عنها",
      issue: "مشكلة",
      imageAlt: "صورة",
      serviceProvider: "مزود الخدمة",
      appointment: "موعد",
      at: "في",
      estimatedCompletion: "الإنجاز المقدر",
      workToBeDone: "العمل المطلوب",
      cost: "التكلفة",
      totalCost: "التكلفة الإجمالية",
      requestDeclined: "تم رفض الطلب",
      communication: "التواصل",
      serviceTeam: "فريق الخدمة",
      noCommunicationYet: "لا يوجد تواصل حتى الآن",
      addMessage: "إضافة رسالة",
      askQuestionPlaceholder: "اطرح سؤالاً أو قدم معلومات إضافية...",
      sending: "جارٍ الإرسال...",
      sendMessage: "إرسال رسالة",
      additionalInformationRequested: "تم طلب معلومات إضافية",
      provideFollowingInformation: "يرجى تقديم المعلومات التالية لمساعدتنا في معالجة طلبك:",
      yourAnswer: "إجابتك:",
      typeAnswerHere: "اكتب إجابتك هنا...",
      submitAnswers: "إرسال الإجابات",
      approved: "تمت الموافقة",
      serviceRequests: "طلبات الخدمة",
      scheduledServicesTitle: "الخدمات المجدولة",
      scheduledServicesBellAria: "عرض خدمات المركبات المجدولة",
      noScheduledServices: "لا توجد خدمات مجدولة",
      approveScheduledServiceSuccess: "تمت الموافقة على الخدمة بنجاح",
      requestChangesSuccess: "تم إرسال طلب التغيير للموافقة",
      requestChanges: "طلب تغييرات",
      modifyServiceRequest: "تعديل طلب الخدمة",
      modifyDetails: "تعديل التفاصيل",
      vehicleAndCategory: "المركبة والفئة",
      cannotModify: "لا يمكن التعديل",
      appointmentDetails: "تفاصيل الموعد",
      time: "الوقت",
      scheduledServiceReviewHint: "يرجى مراجعة الخدمة المجدولة. وافق إذا كانت التفاصيل صحيحة، أو اطلب تغييرات.",
      approveService: "الموافقة على الخدمة",
      jobSheet: "ورقة العمل",
      declined: "مرفوض",
      lastUpdated: "آخر تحديث",
      explainChangesPlaceholder: "اشرح سبب حاجتك إلى هذه التغييرات...",
      submitChanges: "إرسال التغييرات",
      expenses: "المصروفات",
      filters: "مرشحات",
      applyFilters: "تطبيق المرشحات",
      activeFilters: "المرشحات النشطة",
      newServiceRequest: "طلب خدمة جديد",
      rowsPerPage: "صفوف لكل صفحة:",
      of: "من",
      moreThan: "أكثر من",
      searchServiceRequestsPlaceholder: "البحث برقم المرجع أو المركبة أو الحالة...",
      selectOption: "اختر خياراً",
      selectMultiple: "اختر خياراً واحداً أو أكثر",
      uploadPhoto: "رفع صورة",
      view: "عرض",
      typeYourResponse: "اكتب ردك",
      pleaseSelectServiceType: "يرجى اختيار نوع الخدمة",
      pleaseSelectServiceCategory: "يرجى اختيار فئة الخدمة",
      selectServiceType: "اختر نوع الخدمة",
      serviceCategory: "فئة الخدمة",
      selectServiceCategory: "اختر فئة الخدمة",
      unableToDetermineServiceBranch: "تعذر تحديد فرع الخدمة الخاص بك. يرجى المحاولة مرة أخرى لاحقاً.",
      accidentDamageInformation: "معلومات الحادث / الضرر",
      documentUploads: "تحميل المستندات",
      adHoc: "Ad-Hoc",
      emergency: "طوارئ",
      serviceQuestionnaire: "استبيان الخدمة",
      serviceQuestionnaireDescription: "يرجى تقديم بعض التفاصيل الإضافية حتى يتمكن فريق الخدمة لدينا من تحضير كل شيء مسبقاً.",
      selectServiceCategoryPrompt: "اختر فئة خدمة لعرض الأسئلة المطلوبة لهذه الخدمة.",
      noServiceQuestionsForType: "لا توجد أسئلة إضافية لنوع الخدمة هذا. يمكنك المتابعة مع الطلب.",
      fileUploadGuidance: "JPEG/PNG حتى 5 ميجابايت لكل ملف.",
      optionalServiceQuestion: "سؤال اختياري — أجب إذا كان يساعد فريقنا.",
      requestCreated: "تم إنشاء الطلب",
      underReview: "قيد المراجعة",
      inProgress: "قيد التنفيذ",
      photo: "صورة",
      hiThere: "مرحباً،",
      serviceRequestDeclinedMessage: "لقد راجعنا طلب الخدمة الخاص بك، لكنه لم يتمكن من الموافقة عليه في الوقت الحالي.",
      whatWeNeed: "ما نحتاجه:",
      declineReasonGeneric: "قد يكون هذا بسبب تفاصيل مفقودة، أو أهلية الخدمة، أو شروط موافقة أخرى.",
      declineInstruction: "يرجى مراجعة معلوماتك وإرسال طلب جديد بمجرد أن تكون هذه التحديثات في مكانها.",
      answered: "تم الرد",
      pendingAnswer: "في انتظار الرد",
      requiredField: "هذه الاستجابة مطلوبة",
      questionsAnswered: "تم الرد على الأسئلة",
      readyToSubmitChanges: "جاهز لإرسال التحديثات",
      questionsUpToDate: "جميع الردود محدثة",
      updateAnyAnswerToResubmit: "قم بتحديث أي إجابة أعلاه إذا كنت بحاجة إلى إرسال معلومات جديدة.",
      answerTypeText: "نص",
      answerTypeYesNo: "نعم / لا",
      answerTypeDropdown: "قائمة منسدلة",
      answerTypeMultiSelect: "اختيار متعدد",
      answerTypeFileUpload: "رفع صورة",
      pendingApproval: "في انتظار الموافقة",
      awaitingMoreInformation: "في انتظار المزيد من المعلومات",
      closed: "مغلق",
      noServiceRequestsFound: "لم يتم العثور على طلبات خدمة",
      fleetAllocation: "تخصيص الأسطول",
      fleetAllocations: "تخصيصات الأسطول",
      userAgreement: "اتفاقية المستخدم",
      organisationCode: "رمز المؤسسة",
      serviceReference: "مرجع الخدمة",
      completionDate: "تاريخ الإكمال",
      addTask: "إضافة مهمة",
      noTaskFound: "لم يتم العثور على مهام. يمكنك إضافة المهام يدوياً.",
      taskName: "اسم المهمة",
      features: "الميزات",
      interiorFeatures: "الميزات الداخلية",
      exteriorFeatures: "الميزات الخارجية",
      safetyAndTechnicalFeatures: "ميزات السلامة والتقنية",
      otherFeatures: "ميزات أخرى",
      privateHiresNo: "استئجار خاص لا",
      pcoPrivateHiresHireDLNo: "PCO/Private Hire DL لا",
      gender: "الجنس",
      secondaryPhoneNumber: "رقم الهاتف الثانوي",
      secondaryEmailAddress: "عنوان البريد الإلكتروني الثانوي",
      driverAge: "عمر السائق",
      licenceDuration: "مدة الترخيص",
      penaltyPoints: "نقاط الجزاء",
      insuranceClaimsHistory: "تاريخ مطالبات التأمين",
      pcoExpiryDate: "تاريخ انتهاء صلاحية PCO",
      state: "الولاية",
      selectBookingType: "اختر نوع الحجز",
      selectBookingTypeDialog: "يرجى اختيار أحد أنواع الحجز التالية للمتابعة بالحجز",
      regularBooking: "حجز عادي",
      contactlessBooking: "حجز بدون تلامس",
      reviewBookingDetails: "مراجعة تفاصيل الحجز"
    },
    validation: {
      otpLengthMismatch: "يجب أن يكون طول رمز التحقق لمرة واحدة (OTP) ستة أحرف.",
      invalidOtp: "رمز التحقق لمرة واحدة غير صالح",
      required: "{{field}} مطلوب",
      billingEmailInvalid: "يرجى إدخال بريد إلكتروني للفوترة صالح.",
      billingEmailRequired: "البريد الإلكتروني للفوترة مطلوب.",
      phoneNumberRequired: "رقم الهاتف مطلوب.",
      businessNameRequired: "اسم النشاط التجاري مطلوب.",
      registrationNumberRequired: "رقم التسجيل مطلوب",
      vatRequired: "رقم تسجيل ضريبة القيمة المضافة/الضريبة مطلوب",
      accountNumberRequired: "رقم الحساب مطلوب",
      registeredAddressRequired: "العنوان المسجل مطلوب.",
      registeredAddressCountryRequired: "الدولة مطلوبة.",
      registeredAddressStateRequired: "الولاية مطلوبة.",
      registeredAddressCityRequired: "المدينة مطلوبة.",
      registeredAddressStreetRequired: "الشارع مطلوب.",
      tradingAddressRequired: "عنوان النشاط التجاري مطلوب.",
      tradingAddressCountryRequired: "الدولة مطلوبة.",
      tradingAddressStateRequired: "الولاية مطلوبة.",
      tradingAddressCityRequired: "المدينة مطلوبة.",
      tradingAddressStreetRequired: "الشارع مطلوب.",
      contactEmailRequired: "البريد الإلكتروني للتواصل مطلوب.",
      firstNameRequired: "الاسم الأول مطلوب.",
      middleNameRequired: "الاسم الأوسط مطلوب.",
      lastNameRequired: "اسم العائلة مطلوب.",
      addressRequired: "العنوان مطلوب.",
      locationRequired: "الموقع مطلوب.",
      emailIsRequired: "البريد الإلكتروني مطلوب.",
      termsConditionsAccepted: "يجب قبول الشروط والأحكام.",
      streetZipcodeRequired: "الشارع/الرمز البريدي مطلوب.",
      drivingLicenceNumberRequired: "رقم رخصة القيادة مطلوب.",
      nationalInsuranceNumberRequired: "رقم التأمين الوطني مطلوب.",
      nationalityRequired: "الجنسية مطلوبة",
      enterValidPhoneNumber: "أدخل رقم هاتف صالح.",
      enterValidEmailAddress: "يرجى إدخال عنوان بريد إلكتروني صالح.",
      authorityRequired: "الجهة المصدرة مطلوبة.",
      licenceNumberRequired: "رقم الرخصة مطلوب.",
      licenceExpiryDateRequired: "تاريخ انتهاء الرخصة مطلوب.",
      expiryDateRequired: "تاريخ الانتهاء مطلوب.",
      numberIsRequired: "الرقم مطلوب.",

      passwordLengthValidaion: "يجب أن يكون طول كلمة المرور 8 أحرف أو أكثر.",
      passwordContainUppercase:
        "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل.",
      passwordContainLowercase:
        "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل.",
      passwordContainOneNumber:
        "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.",
      passwordContainSpecialCharacter:
        "يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل.",
      passwordMustMatch: "يجب أن تتطابق كلمتا المرور.",
      atleastOneUppercase: "حرف كبير واحد على الأقل.",
      atleastOneLowercase: "حرف صغير واحد على الأقل.",
      atleastOneNumericalChar: "رقم واحد على الأقل.",
      atleastOneSpecialChar: "رمز خاص واحد على الأقل.",
      pleaseEnterAValidEmail: "يرجى إدخال بريد إلكتروني صالح.",
      driverNotFound: "لم يتم العثور على السائق.",
      batteryStatusNumber: "يجب أن تكون حالة البطارية رقماً.",
      batteryStatusCantNegative: "لا يمكن أن تكون حالة البطارية سالبة.",
      batteryStatusCantMoreHundred: "لا يمكن أن تتجاوز حالة البطارية 100٪.",
      batteryStatusRequired: "حالة البطارية مطلوبة.",
      odometerReadingMustNumber: "يجب أن تكون قراءة العداد رقماً.",
      odometerReadingRequired: "قراءة العداد مطلوبة.",
      odometerMustEqualOrHigherLast:
        "يجب أن تكون قراءة العداد مساوية أو أعلى من آخر قراءة مسجلة.",
      titleIsRequired: "العنوان مطلوب.",
      damageKindIsRequired: "نوع الضرر مطلوب.",
      descriptionIsRequired: "الوصف مطلوب.",
      damageImageIsRequired: "صورة الضرر مطلوبة.",
      professionIsRequired: "المهنة مطلوبة",
      passportNineCharacters: "يجب أن يكون رقم جواز السفر من 9 أحرف",
      passportIsRequired: "جواز السفر مطلوب",
      organisationCodeRequired: "رمز المؤسسة مطلوب",
      userNotFound: "المستخدم غير موجود",
      invalidPassword: "كلمة مرور خاطئة",
      passwordLengthError: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل",
      customerPCONumberRequired: "رقم رخصة PCO / التأجير الخاص مطلوب",
      genderRequired: "الجنس مطلوب",
    },
    misc: {
      edit: "تعديل",
      logOut: "تسجيل الخروج",
      licence: "الرخصة",
      cancel: "إلغاء",
      save: "حفظ",
      status: {
        PENDING: "قيد الانتظار",
        APPROVED: "تمت الموافقة",
        DECLINED: "مرفوض",
        IN_REVIEW: "قيد المراجعة",
      },
      delete: "حذف",
      create: "إنشاء",
      signIn: "تسجيل الدخول",
      select: "اختيار",
      back: "رجوع",
      error: "خطأ",
      yes: "نعم",
      no: "لا",
      payConfirm: "ادفع و أكد",
      clickToAdd: "اضغط للإضافة",
      close: "إغلاق",
      download: "تنزيل",
      selectCaps: "اخْتَر",

      forgotPassword: "نسيت كلمة المرور",
      pleaseNote: "يرجى الملاحظة",
      front: "أمامي",

      columnKey: {
        "#": "#",
        Particulars: "تفاصيل",
        Quantity: "الكمية",
        "Unit Price": "سعر الوحدة",
        Duration: "المدة",
        "Discounted Price": "السعر المخفض",
        "VAT/TAX": "ضريبة القيمة المضافة/الضريبة",
        Amount: "المبلغ",
      },
      columnLabelToKeyMap: {
        ITEM: "العنصر",
        DESCRIPTION: "الوصف",
        QUANTITY: "الكمية",
        "UNIT PRICE": "سعر الوحدة",
        DURATION: "المدة",
        "DISCOUNTED PRICE": "السعر المخفض",
        "VAT/TAX": "ضريبة القيمة المضافة/الضريبة",
        PRICE: "السعر",
      },
      paymentColumnsKey: {
        Date: "التاريخ",
        Amount: "المبلغ",
        "Mode Of Payments": "طريقة الدفع",
        Status: "الحالة",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "رقم مرجع الفاتورة",
        "Vehicle Registration Numbers": "رقم (أرقام) تسجيل المركبة"

      },
      buttonKey: {
        Rentals: "تأجير",
        Subscriptions: "اشتراكات",
        "Test Drive": "تجربة قيادة",
        "Contract Hire": "عقد إيجار",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "احجز المركبة بالساعات أو الأيام",
        "Subscribe vehicle for weekly/monthly":
          "اشترك بالمركبة أسبوعياً/شهرياً",
        "Test Drive our Premium Vehicles": "جرّب قيادة مركباتنا المميزة",
        "Contract Hire vehicle for weekly/monthly": "استأجر بعقد أسبوعي/شهري",
      },
      buttonTextKey: {
        "Subscribe Now": "اشترك الآن",
        "Book Now": "احجز الآن",
        "Contract Now": "استأجر الآن",
      },
      featuresKey: {
        "Flexible Leasing Options": "خيارات تأجير مرنة",
        "Choose the duration of your subscription as you go":
          "اختر مدة اشتراكك حسب الحاجة",
        "Change car anytime*": "غيّر السيارة في أي وقت*",
        "Home delivery option": "خدمة التوصيل للمنزل",
        "100% digital": "رقمي بنسبة 100%",
        "MOT and taxes": "فحص المركبة والضرائب",
        "Without down payment": "بدون دفعة مقدمة",
        "Vehicle Servicing": "خدمة صيانة المركبة",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "المبلغ",
        "Adjusted To Invoice": "تمت التسوية مع الفاتورة",
        "Adjusted At": "تمت التسوية في",
      },
      categoriesKey: {
        Knowledge: "المعرفة",
        Behavior: "السلوك",
        Punctuality: "الالتزام بالمواعيد",
      },
    },
    snackBar: {
      customerInfoSaved: "تم حفظ معلومات العميل",
      documentDeleted: "تم حذف المستند بنجاح",
      documentDeleteFailed: "فشل في حذف المستند",
      documentDeleteError: "حدث خطأ أثناء حذف المستند",
      documentMarkedForDeletion:
        "تم تعليم المستند للحذف. سيتم تطبيق التغييرات عند الحفظ.",
      profileImageUploaded: "تم تحميل صورة الملف الشخصي بنجاح",
      uploadImageFormatError: "يرجى تحميل صور بصيغة .jpeg أو .jpg أو .png فقط!",
      selectDocumentType: "يرجى اختيار نوع المستند",
      selectExpiryDate: "يرجى اختيار تاريخ انتهاء الصلاحية",
      fileSizeExceeded50mb: "تم تجاوز الحد الأقصى لحجم الملف وهو 50 ميجابايت",
      fileSizeExceeded5mb: "تم تجاوز الحد الأقصى لحجم الملف وهو 5 ميجابايت",
      uploadSuccess: "تم تحميل المستند بنجاح",
      invalidUploadFormat: "يرجى تحميل ملفات PDF أو PNG أو JPG أو JPEG فقط",
      selectExpiryDateUpload: "يرجى اختيار تاريخ الانتهاء قبل التحميل",
      ImageUploaded: "تم تحميل الصورة بنجاح",

      invalidFileType: "نوع ملف غير صالح. الأنواع المسموح بها: jpeg أو png",
      costCenterInfoMissing: "معلومات مركز التكلفة مفقودة!",
      selectedDriverAlreadyAdded: "تم إضافة السائق المحدد مسبقاً.",
      driverSavedSuccessfully: "تم حفظ السائق بنجاح.",
      additionalDriverCannotBeMore:
        "لا يمكن أن يتجاوز عدد السائقين الإضافيين كمية الإضافة",
      verificationStatusInReview: "حالة التحقق قيد المراجعة",
      verificationStatusPending: "حالة التحقق قيد الانتظار",
      quoteCreated: "تم إنشاء عرض السعر",
      bookingCreated: "تم إنشاء الحجز",
      pickUpLocationEmpty: "موقع الاستلام فارغ",
      "slotSelectionRequiredForNonNegotiable": "مطلوب اختيار الوقت.",
      protectionPlanMandatoryForPCOBooking: "خطة الحماية إلزامية لحجوزات PCO",
      paymentAlreadyDone: "تم الدفع مسبقاً",
      fileBeingGenerated: "يتم إنشاء الملف، يرجى المحاولة لاحقاً",

      provideDeliveryAddress: "يرجى تقديم عنوان التسليم!",
      noValidCreditReadingFound:
        "لم يتم العثور على قراءة ائتمانية صالحة لهذه الشركة.",
      noValidCreditScoreFound:
        "لم يتم العثور على درجة ائتمانية صالحة. قد يكون ذلك بسبب تجاوز الحد المسموح به لفحوصات الائتمان.",

      atleastOneLicenceImage: "يرجى تحميل صورة واحدة على الأقل للرخصة",
      licenceImageUploaded: "تم تحميل صورة الرخصة بنجاح",
      maximumTwoImageLicence: "يمكن تحميل صورتين كحد أقصى للرخصة!",
      imageUploadInProgress: "يرجى الانتظار، يتم تحميل الصورة!",

      errorFetchingSignedUrl: "حدث خطأ أثناء جلب رابط التوقيع",
      paymentFailed: "فشل الدفع، يرجى المحاولة مرة أخرى",
      paymentFailedReasonCardDetails:
        "فشل الدفع! يرجى التحقق من تفاصيل البطاقة أو المحاولة لاحقاً.",
      maximumTwoImage: "يمكن تحميل صورتين كحد أقصى لـ",

      cancelledSuccessfully: "تم الإلغاء بنجاح",
      selectReasonForCancel: "يرجى إدخال سبب الإلغاء",
      streetZipcodeRequired: "الشارع / الرمز البريدي مطلوب",
      feedbackSaved: "شكرًا لك! تم حفظ ملاحظاتك",
      driverAlreadyAdded: "السائق مضاف بالفعل!",
      driverRemoved: "تمت إزالة السائق بنجاح",
      businessCustomerDriverDeleted: "تم حذف سائق العميل التجاري.",
      errorInSavingData: "حدث خطأ أثناء حفظ البيانات",
      damageInformationSaved: "تم حفظ معلومات الضرر بنجاح.",
      errorSavingData: "حدث خطأ أثناء حفظ البيانات",
      problemTelematicsData: "حدثت مشكلة أثناء تحميل بيانات التيليماتيك",

      verificationRequestSent: "تم إرسال طلب التحقق بنجاح.",
      vehicleStateUpdated: "تم تحديث حالة المركبة",
      driverAdded: "تمت إضافة السائق.",
      businessCustomerCreated: "تم إنشاء العميل التجاري.",
      uploadOnlyImageFiles: "يرجى تحميل ملفات الصور فقط (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "يجب ألا يتجاوز حجم الصورة 5 ميجابايت",
      uploadFailed: "فشل التحميل",
      imagesUploadedSuccessfully: "تم تحميل الصورة/الصور بنجاح!",
      failedToUploadImages: "فشل تحميل الصور. يرجى المحاولة مرة أخرى.",
      pleaseSelectVehicle: "يرجى اختيار مركبة",
      pleaseFillInAllIssueDetails: "يرجى ملء جميع تفاصيل المشكلة",
      serviceRequestCreatedSuccessfully: "تم إنشاء طلب الخدمة بنجاح! المرجع:",
      errorCreatingServiceRequest: "خطأ في إنشاء طلب الخدمة",
      pleaseEnterNote: "يرجى إدخال ملاحظة",
      noteAddedSuccessfully: "تمت إضافة الملاحظة بنجاح",
      errorAddingNote: "خطأ في إضافة الملاحظة",
      pleaseAnswerAllRemainingQuestions: "يرجى الإجابة على جميع الأسئلة{{plural}} الـ {{count}} المتبقية",
      answersSubmittedSuccessfully: "تم إرسال الإجابات بنجاح! طلبك قيد المراجعة الآن.",
      errorSubmittingAnswers: "خطأ في إرسال الإجابات",
      serviceRequestNotFound: "لم يتم العثور على طلب الخدمة",
      errorLoadingServiceRequests: "خطأ في تحميل طلبات الخدمة",
      oneVehicleForContactless: "يمكن اختيار مركبة واحدة فقط للحجز بدون تلامس",
      oneVehicleForNonContactless: "يمكن اختيار مركبة بدون تلامس أو مركبة ذكية فقط للحجز بدون تلامس",
      contactlessVehicleCannotBeSelected: "لا يمكن اختيار مركبة بدون تلامس للحجوزات العادية",
      bookingDetailsCreated: "تم إنشاء تفاصيل الحجز"
    },
  },
};